import { useWindow } from '@uds/hooks';
import { ConfigureProductCta } from 'core/ribbons/cta';

import { formatPricingTier } from './utils';

interface Props {
  behavior?: ConfigureProductCta;
}

export default () => {
  const window = useWindow();

  return ({ behavior }: Props) => {
    const tier = formatPricingTier(behavior?.pricingTier);
    const productId = behavior?.productId;
    const query = new URLSearchParams();

    if (productId != null) {
      query.append('productId', productId);
    }

    if (tier != null) {
      query.append('pricingTier', tier);
    }

    const q = query.toString();
    window.location.href = `/configure?${q}`;
  };
};
